<template>
  <div v-if="hasAuth">
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <el-button style="width:100%;" type="secondary" size="small" @click="onClickExecuteDeviceInfoUpdate">장비 정보 업데이트</el-button>
      </el-col>
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
      </el-col>
      <el-col :span="12">
        <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <el-button style="width:100%;" type="secondary" size="small" @click="$refs.databaseQueryExecutorPopup.open()">쿼리수행기</el-button>
      </el-col>
      <el-col :span="12">
        <w-database-connected-device-analysis-button :objInfo="objInfo" @change-page="$emit('change-page')" />
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b25">
      <el-col :span="12">
        <w-simulation-predict-popup-button :obj="objInfo" />
      </el-col>
    </el-row>
    <w-basic-sliding-button-group :obj-info="objInfo" />
    <w-database-query-executor-popup :obj-info="objInfo" ref="databaseQueryExecutorPopup"/>
  </div>
  <div v-else>
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth" />
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <w-database-connected-device-analysis-button :objInfo="objInfo" @change-page="$emit('change-page')" />
      </el-col>
      <el-col :span="12">
        <w-simulation-predict-popup-button :obj="objInfo" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import databaseInfoAPI from '@/api/performance/database/database-info';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WDatabaseQueryExecutorPopup from './DatabaseQueryExecutorPopup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WDatabaseConnectedDeviceAnalysisButton from './DatabaseConnectedDeviceAnalysisButton';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';
import WSimulationPredictPopupButton from './button/common/SimulationPredictPopupButton';

export default {
  name: 'WDatabaseSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WDatabaseQueryExecutorPopup,
    WCommonSettingChartTypePopupButton,
    WDatabaseConnectedDeviceAnalysisButton,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
    WSimulationPredictPopupButton,
  },
  mixins: [HambugerPopupMixin],
  methods: {
    /**
     * [onClickExecuteDeviceInfoUpdate 장비정보 업데이트]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteDeviceInfoUpdate() {
      databaseInfoAPI
        .executeDatabaseDeviceInfoUpdate({ objId: this.objInfo.obj.objId })
        .then((result) => {
          if (result.data.success === true) {
            this.notification('장비 정보 업데이트');
          }
        });
    },
    /**
     * [notification 수행완료 notify]
     * @author {Yang}
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    notification(title) {
      this.$notify({
        title,
        customClass: 'center',
        message: `${this.objInfo.obj.objName}에 대한 ${title}를 수행하였습니다.`,
        duration: 2000,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/DatabaseSlidingButtonGroup.vue